import { useEffect } from "react";

const BASE = "https://anainternationalpvt.com";

export const SEO = ({ title, description, path = "/", jsonLd }) => {
    useEffect(() => {
        document.title = title;
        const setMeta = (attr, key, content) => {
            let el = document.head.querySelector(`meta[${attr}="${key}"]`);
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute(attr, key);
                document.head.appendChild(el);
            }
            el.setAttribute("content", content);
        };
        setMeta("name", "description", description);
        setMeta("property", "og:title", title);
        setMeta("property", "og:description", description);
        setMeta("property", "og:url", `${BASE}${path}`);
        setMeta("name", "twitter:title", title);
        setMeta("name", "twitter:description", description);

        let link = document.head.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement("link");
            link.rel = "canonical";
            document.head.appendChild(link);
        }
        link.href = `${BASE}${path}`;

        let script = document.getElementById("page-jsonld");
        if (jsonLd) {
            if (!script) {
                script = document.createElement("script");
                script.id = "page-jsonld";
                script.type = "application/ld+json";
                document.head.appendChild(script);
            }
            script.textContent = JSON.stringify(jsonLd);
        } else if (script) {
            script.remove();
        }
    }, [title, description, path, jsonLd]);
    return null;
};
